import { useTranslation } from 'react-i18next';
import { useFetcher } from 'react-router';
import type { FetcherData } from 'types';

import ErrorIcon from '~/assets/icons/Error';
import { Button } from '~/components/Button';
import TextInput from '~/components/Form/TextInput';

import ModalHeadings from '../ModalHeadings';

export default function ForgotPasswordScreen() {
  const fetcher = useFetcher<FetcherData>();
  const { t } = useTranslation();

  const errors = fetcher.data?.errors;
  const success = fetcher.data?.success;
  const submitting = fetcher.state === 'submitting';

  return (
    <>
      <ModalHeadings>{t('login.stageForgotPassword.subHeading')}</ModalHeadings>
      <div className="flex w-full flex-col items-start gap-4 bg-black">
        <fetcher.Form
          action="/bolt/reset-password/"
          className="flex size-full flex-col items-start gap-4"
          method="post"
        >
          <TextInput
            className="h-12 w-full rounded-md p-4"
            error={errors?.email ? t('login.emailFormatError') : undefined}
            id="password-reset-email"
            name="email"
            placeholder={t('login.emailAddress')}
            type="email"
          />
          <Button
            className="h-12 w-full"
            variant={success ? 'disabled' : 'green-human'}
            disabled={success}
          >
            {submitting
              ? t('login.stageForgotPassword.resetting')
              : t('login.stageForgotPassword.resetButton')}
          </Button>
          {errors?.notFound && <AccountNotFoundMessage />}
          {success && (
            <p className="text-base text-white">
              {t('login.stageForgotPassword.successMessage')}
            </p>
          )}
        </fetcher.Form>
      </div>
    </>
  );
}

function AccountNotFoundMessage() {
  const { t } = useTranslation();

  return (
    <div className="flex h-5 flex-row content-center items-center gap-1">
      <ErrorIcon />
      <p className="text-xs font-bold text-red-600">
        {t('login.stageForgotPassword.noAccountError')}
      </p>
    </div>
  );
}
